<div class="content-header">
	<div class="container-fluid">
		<div class="row">
			<div class="col-sm-12">
				<h1 class="m-0 text-dark">{{rutas[rutas.length - 1].nombre | uppercase}}</h1>
			</div>
			<div class="col-sm-12">
				<ol class="breadcrumb">
					<li class="breadcrumb-item" [routerLink]="['/main']"><small>Inicio</small></li>
					<li *ngFor="let i of rutas" class="breadcrumb-item" [routerLink]="[i.link]" routerLinkActive="active"><small>{{i.nombre}}</small></li>
				</ol>
			</div>
		</div>
	</div>
</div>